import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';

import { DsButton } from '@frontend/ui/button';

import { PlainLinkBehaviorDirective } from './plain-link-behavior.directive';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'a[ds-button]',
    imports: [CommonModule],
    hostDirectives: [PlainLinkBehaviorDirective],
    templateUrl: '../../../../../design-system/ui/button/src/button.component.html',
    styleUrl: '../../../../../design-system/ui/button/src/button.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class ButtonBehaviorComponent extends DsButton {}
